import { styled } from '@mui/material/styles';
import { css } from '@mui/styled-engine';

import theme from '@/styles/theme';

const ARROW_WIDTH = 38;
const ARROW_HEIGHT = 32;

const leftArrowStyles = css({
  right: ARROW_WIDTH,
  borderRightWidth: 0,
  borderLeft: 1,
  boxShadow: `${ARROW_WIDTH / 2}px 18px 24px 9px ${
    theme.palette.grayscale[200]
  }`,
  '&:after': {
    position: 'absolute',
    content: '""',
    border: `1px solid ${theme.palette.grayscale[100]}`,
    right: 0,
    top: 0,
    bottom: 0,
  },
});

const rightArrowStyles = css({
  right: 0,
  borderRightWidth: 1,
  borderLeft: 0,
});

export const Wrapper = styled('button', {
  shouldForwardProp: prop => prop !== 'direction',
})(({ theme, direction }) => [
  {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    bottom: 0,
    zIndex: 1,
    backgroundColor: theme.palette.common.white,
    width: ARROW_WIDTH,
    height: ARROW_HEIGHT,
    border: `1px solid ${theme.palette.grayscale[100]}`,
    outline: 'none',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.palette.grayscale[200],
    },
  },
  direction === 'left' ? leftArrowStyles : rightArrowStyles,
]);
